import script from "./LatestBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./LatestBlock.vue?vue&type=script&setup=true&lang=js"

import "./LatestBlock.vue?vue&type=style&index=0&id=17f10ba0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17f10ba0"]])

export default __exports__